import { render, staticRenderFns } from "./cos.vue?vue&type=template&id=6eb4beda&"
import script from "./cos.vue?vue&type=script&lang=js&"
export * from "./cos.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "cos.vue"
export default component.exports